'use strict';

(function () {
    'use strict';

    angular.module('groups', ['ui.router', 'common', 'group.selectionGroups']);
})();